<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver3">
    <Error_messages :error_message="messages.error" :success_message = "messages.success"/>
      <form @submit.prevent="handleSubmit(register)" ref="form3">
        <ValidationProvider name="name" :rules="rules.name" v-slot="{ passed, failed, failedRules, errors  }">
          <b-form-group label="Name" label-for="name" >
            <b-form-input id="name" :class="{'is-invalid':errors.length}" 
              type="text" placeholder="Enter your name..." v-model="form.name" ></b-form-input>
              <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.name ? validation_messages.name[Object.keys(failedRules)[0]] : errors[0] }} </div>
            </b-form-group>
        </ValidationProvider>

        <ValidationProvider name="businessType" :rules="rules.businessType"
                            v-slot="{ passed, failed, failedRules, errors  }">
        <div class="form-group">
                    <template>
                      <b-form-select 
                      v-model="form.businessType" 
                      class="w-300 form-control" 
                      :class="{ 'is-invalid': errors.length > 0 }"
                      >
                        <b-form-select-option value="" >{{ $t("Select business type") }} </b-form-select-option>
                        <b-form-select-option
                        v-for="type in businessTypes"
                        :value="type" :key="type">{{ $t(type) }}
                      </b-form-select-option>
                    </b-form-select>
                  </template>
                  <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.businessType ? validation_messages.businessType[Object.keys(failedRules)[0]] : errors[0] }} </div>
        </div>
          
        </ValidationProvider>

        <ValidationProvider name="businessName" :rules="rules.businessName"
                            v-slot="{ passed, failed, failedRules, errors  }">

            <b-form-group label="BusinessName" label-for="BusinessName" >
            <b-form-input id="BusinessName" :class="{'is-invalid':errors.length}" 
              type="text" placeholder="Enter your businessName..." v-model="form.businessName" ></b-form-input>
              <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.businessName ? validation_messages.businessName[Object.keys(failedRules)[0]] : errors[0] }} </div>
            </b-form-group>
        </ValidationProvider>

        <ValidationProvider name="password" :rules="rules.password" v-slot="{passed, failed, failedRules, errors  }">
         
          <b-form-group label="Password" label-for="password" >
            <b-form-input id="password" :class="{'is-invalid':errors.length}" 
              type="password" placeholder="Enter your password..." v-model="form.password" ></b-form-input>
              <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.password ? validation_messages.password[Object.keys(failedRules)[0]] : errors[0] }} </div>
            </b-form-group>
        </ValidationProvider>

        <ValidationProvider name="acceptTerms" :rules="rules.acceptTerms"
                            v-slot="{passed, failed, failedRules, errors  }">
         <div class="form-group">
          <b-checkbox class="text-left" v-model="form.acceptTerms " :class="{'is-invalid':errors.length}" 
                      id="acceptTerms"
                      :hasSuccess="passed"
                  
                       >
            I agree to the
            <a href="#terms-and-conditions">terms and conditions</a>.
          </b-checkbox>
          <div v-if="errors.length" class="invalid-feedback"> {{ failed && validation_messages.acceptTerms ? validation_messages.acceptTerms[Object.keys(failedRules)[0]] : errors[0] }} </div>
        </div>
        </ValidationProvider>
        <b-spinner v-if="loading" variant="primary" class="float-right" label="Spinning"></b-spinner>
        <button v-else type="submit" class="btn btn-primary float-right">Register</button>

      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {registerUser} from "@/API/UsersAPIs";
import {listBusinessTypes} from "@/API/BusinessAPIs";
import { setAccessToken } from "@/Utils/authentication";
import Error_messages from "@/helpers/error_messages.vue";
export default {
  props: [
    'email',
    'code',
    'phone'
  ],
  components: {Error_messages},
  data() {
    return {
      loading: false,
      messages: { error: "", success: "" },
      businessTypes: [],
      form: {
        name: '',
        businessType: '',
        businessName: '',
        email: '',
        phone: '',
        password: '',
        acceptTerms: null,
        code: '',
        password_confirmation: ''
      },
      rules: {
        name: 'required|min:5',
        businessType: 'required',
         businessName: 'required|min:5',
        password: 'required|min:8',
        acceptTerms: 'required'
      },
      validation_messages: {
        name: {
          required: 'Your name is required',
          min: 'Minimum length 5 characters required'
        },
        businessType: {
          required: 'Select business please',
        },
        businessName: {
          required: 'Business Name  is required',
          min: 'Minimum length 5 characters required'
        },
        password: {
          required: 'Password is required',
          min: 'Minimum length 8 characters required'
        },
        acceptTerms: {
          required: 'Please agree our terms & conditions'
        }
      }
    }
  },
  async mounted() {
    if (this.email){
      this.form={
        name: '',
        businessType: '',
        businessName: '',
        email:this.email,
        password: '',
        acceptTerms: null,
        code: '',
        password_confirmation: ''
      }
    }else if (this.phone){
      this.form={
        name: '',
        businessType: '',
        businessName: '',
        phone:this.phone,
        password: '',
        acceptTerms: null,
        code: '',
        password_confirmation: ''
      }
    }
    this.form.code = this.code;
    this.businessTypes = await listBusinessTypes();
  },
  methods: {

    async register() {
      if(this.form.acceptTerms === true){
      this.loading = true ;
      this.form.password_confirmation = this.form.password;
      try{
          const user = await registerUser(this.form)
          console.log(user)
          this.$store.commit('User/setUser', user);
          setAccessToken(user.token)
          this.messages.error="";
          this.loading = false;
          return window.location.replace('/');
        }
        catch(error){
          this.messages.error = error.message === "Network Error" 
          ? error.message 
          : error.response.data.errors.phone_required[0]
           this.loading = false
        }
        finally{this.loading = false}
    }
        
    },
  },
  watch: {
    email(value) {
      this.form.email = value;
    },
    code(value) {
      this.form.code = value;
    },
  }
}
</script>

<style scoped>

</style>
